// Used for  RetFlex and subvention rows
export default {
  computed: {
    fullUserName () {
      let fullUserName = ''

      if (this.user && this.user.firstName) {
        fullUserName += this.user.firstName
      }
      if (this.user && this.user.lastName) {
        fullUserName += ' ' + this.user.lastName
      }
      return fullUserName
    },
    userProfilePictureId () {
      return this.user && this.user.profilePicture
        ? this.user.profilePicture.id
        : 0
    },
    // Revisar beneficios a ver si se usa, parece que ya no es necesario
    officeConfig () {
      return this.$store.getters['CompanyStore/currentCompany'].configs || {}
    },
    // Ret Flex information

    /* - Ret Flex : Restaurants - */
    foodFlexibleRemunerationBudget () {
      return this.user && this.user.flexibleRemunerationUserBudgets.length > 0 ? this.user.flexibleRemunerationUserBudgets.find(el => el.activityGroup.code === 'RESTAURANTS') : false
    },
    // Used for Bars and ret flex
    foodAssigned () {
      return this.foodFlexibleRemunerationBudget ? this.foodFlexibleRemunerationBudget.flexRemAssigned : 0
    },
    foodSpent () {
      return this.foodFlexibleRemunerationBudget ? this.foodFlexibleRemunerationBudget.flexRemSpent : 0
    },
    foodAvailable () {
      return this.foodFlexibleRemunerationBudget && this.foodFlexibleRemunerationBudget.available ? this.foodFlexibleRemunerationBudget.available : 0
    },

    /* - Ret Flex: Transports - */
    transportFlexibleRemunerationBudget () {
      return this.user && this.user.flexibleRemunerationUserBudgets.length > 0 ? this.user.flexibleRemunerationUserBudgets.find(el => el.activityGroup.code === 'TRANSPORT') : false
    },
    // Used for Bars and Ret Flex
    transportAssigned () {
      return this.transportFlexibleRemunerationBudget ? this.transportFlexibleRemunerationBudget.flexRemAssigned : 0
    },

    transportSpent () {
      return this.transportFlexibleRemunerationBudget ? this.transportFlexibleRemunerationBudget.flexRemSpent : 0
    },
    transportAvailable () {
      return this.transportFlexibleRemunerationBudget && this.transportFlexibleRemunerationBudget.available ? this.transportFlexibleRemunerationBudget.available : 0
    },
    /* - Ret Flex: Nursery - */
    nurseryFlexibleRemunerationBudget () {
      return this.user && this.user.flexibleRemunerationUserBudgets.length > 0 ? this.user.flexibleRemunerationUserBudgets.find(el => el.activityGroup.code === 'NURSERY') : false
    },
    /* - Ret Flex: Insurance - */
    insuranceFlexibleRemunerationBudget () {
      return this.user && this.user.flexibleRemunerationUserBudgets.length > 0 ? this.user.flexibleRemunerationUserBudgets.find(el => el.activityGroup.code === 'INSURANCE') : false
    },
    insurancePolicyHolders () {
      return this.user && this.user.healthInsurance ? this.user.healthInsurance.policyHoldersNumber : 0
    },
    insuranceDisabledPolicyHolders () {
      return this.user && this.user.healthInsurance ? this.user.healthInsurance.disabledPolicyHoldersNumber : 0
    },
    /* - Ret Flex: Education - */
    educationFlexibleRemunerationBudget () {
      return this.user && this.user.flexibleRemunerationUserBudgets.length > 0 ? this.user.flexibleRemunerationUserBudgets.find(el => el.activityGroup.code === 'EDUCATION') : false
    },
    // Superadmin - Edit of other ret flex
    isImpersonating () {
      return this.$store.getters['LoginStore/isImpersonating']
    }

  },
  methods: {
    async fetchUsers (event) {
      let defaultFilters = {
        'status.statusType.code': ['ACTIVE'],
        roles: ['ROLE_REGULAR', 'ROLE_ADMIN']
      }
      let searchFilters = {}
      if (event) {
        if (event.length < 3) return // Prevent multiple search calls s
        searchFilters.query = event
      }
      const filters = { ...defaultFilters, ...searchFilters }
      await this.$store.dispatch('UsersStore/setUsersFilters', { filters: filters })
    },
    async setInsuranceHolders (insuranceHolderType) {
      let insuranceHoldersData = {
        id: this.user.id,
        healthInsurance: {
        }
      }

      if (insuranceHolderType === 'regular') {
        insuranceHoldersData.healthInsurance['policyHoldersNumber'] = this.insurancePolicyHoldersValue
      } else {
        insuranceHoldersData.healthInsurance['disabledPolicyHoldersNumber'] = this.insuranceDisabledPolicyHoldersValue
      }

      try {
        await this.$store.dispatch('UsersStore/updateUser', insuranceHoldersData)
      } catch (error) {
        if (insuranceHolderType === 'regular') {
          this.insurancePolicyHoldersValue = this.insurancePolicyHolders
        } else {
          this.insuranceDisabledPolicyHoldersValue = this.insuranceDisabledPolicyHolders
        }
      }
    },
    // Columns Handler
    isColumnVisible (key) {
      const column = this.columns.find(c => c.key === key)
      if (column && column.visible) return true
      return false
    },
    showPolicyHoldersWarning () {
      if (this.insurancePolicyHolders === 0 && this.insuranceDisabledPolicyHolders === 0) {
        this.$store.dispatch('SnackBars/addWarning', this.$i18n.t('snackbars_insurance_policy_holders_warning'))
      }
    }
    // async setUserFeature (userId, feature) {
    //   let user = this.$store.getters['UsersStore/users'].find(
    //     el => el.id === userId
    //   )

    //   let featuresToAdd = user.activatedFeatures
    //   let featureToAddExists = user.activatedFeatures.findIndex(
    //     el => el.feature.code === feature
    //   )

    //   if (
    //     (!user.grossSalary ||
    //       user.grossSalary < MINIMUM_GROSS_SALARY_RET_FLEX) &&
    //     featureToAddExists < 0
    //   ) {
    //     this.$emit('showRequestGrossSalaryModal', {
    //       featureRequested: feature,
    //       userId: this.user.id
    //     })
    //     return
    //   }

    //   let segmentBenefitUpdatedTraits = {
    //     user_id: '',
    //     benefit_updated: '',
    //     status: ''
    //   }
    //   // Feature doesnt exist
    //   if (!(featureToAddExists !== -1)) {
    //     let { id: featureToBeAddedId, name: featureName } = this.features.find(
    //       el => el.code === feature
    //     )
    //     featuresToAdd.push({ feature: { id: featureToBeAddedId } })
    //     segmentBenefitUpdatedTraits.user_id = user.id
    //     segmentBenefitUpdatedTraits.benefit_updated = featureName
    //     segmentBenefitUpdatedTraits.status = true
    //   } else {
    //     // Feature exists, remove it

    //     let featureToRemove = user.activatedFeatures.find(
    //       el => el.feature.code === feature
    //     )

    //     featuresToAdd.splice(featureToAddExists, 1)
    //     segmentBenefitUpdatedTraits.user_id = user.id
    //     segmentBenefitUpdatedTraits.benefit_updated =
    //       featureToRemove.feature.name
    //     segmentBenefitUpdatedTraits.status = false
    //   }

    //   let updateInformation = {
    //     id: user.id,
    //     activatedFeatures: [...featuresToAdd]
    //   }

    //   await this.$store.dispatch('UsersStore/updateUser', updateInformation)
    //   segmentTrack('User benefit updated', segmentBenefitUpdatedTraits)
    // }

  }
}
